import React from "react";
import PropTypes from "prop-types";
import { Accordion } from "./NBAccordion";
import { Box, HStack, } from "~/native-ui/native-base";
import { Animated } from "react-native";
import { AccordionItemContext } from "./NBAccordion/Context";

const AccordionIsExpandedHandler = ({ onToggle }) => {
    const { isOpen } = React.useContext(AccordionItemContext);
    React.useEffect(() => { onToggle({isOpen}) }, [ isOpen ]);

    return null;
}
export class AccordionItem extends React.PureComponent {
    isOpen = false;

    hoverAnimation = new Animated.Value(0);

    static propTypes = {
        variant: PropTypes.string, 
        index: PropTypes.number, 
        body: PropTypes.node,
        isActive: PropTypes.bool,
        getItemIndex: PropTypes.func,
        ActiveBackgroundComponent: PropTypes.elementType,
        label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired
    }


    getItemIndex() {
        return this.props.getItemIndex?.(this.props.index) ?? this.props.index;
    }

    renderActiveBackground() {
        const ActiveBackgroundComponent = this.props.ActiveBackgroundComponent;
        if (!ActiveBackgroundComponent) {
            return;
        }

        return <ActiveBackgroundComponent isActive={this.props.isActive} hoverAnimation={this.hoverAnimation} />
    }

    
    renderAccordionIcon() {
        if (this.props.onClick) return null;
        return <Accordion.Icon variant={this.props.variant} />
    }

    animate (toValue) {
        return Animated.spring(this.hoverAnimation, {
            toValue: toValue === 1,
            useNativeDriver: false,
            bounciness: 2,
            isInteraction: true,
            speed: 10,
        });
    }

    onMouseEnter = () => {
        this.animate(1).start();
    }

    onMouseLeave = () => {
        if (this.isOpen) { return };
        this.animate(0).start();
    }

    onToggle = ({ isOpen }) => {
        this.isOpen = isOpen;
        this.onMouseLeave();
    }
    
    render() {
        const { icon, label, onClick: onPress, children, body, variant, _toggle = {}, _body = {} } = this.props;

        const itemProps = {
            index: this.getItemIndex(),
            onMouseEnter: this.onMouseEnter,
            onMouseLeave: this.onMouseLeave,
        }

        const toggleProps = {
            variant,
            onPress,
            ..._toggle,
        }

        const bodyProps = {
            variant,
            ..._body
        }


        return (
            <Accordion.Item { ...itemProps }>
                <AccordionIsExpandedHandler onToggle={this.onToggle} />
                <Accordion.Summary { ...toggleProps }>
                    { this.renderActiveBackground() }
                    <HStack space="2" alignItems="center" color="inherit">
                        { icon }
                        { label }
                    </HStack>
                    { this.renderAccordionIcon() }
                </Accordion.Summary>
                <Accordion.Details { ...bodyProps }>
                    { body }
                    { children }
                </Accordion.Details>
            </Accordion.Item>
        )
    }
};